export default __webpack_public_path__ + "static/media/waning-crescent.ed3dd388.svg";